/**
 * Empresas (`getConfigName`) que ya usan el acceso del diseño v2: login, recuperar y nueva contraseña. Las rutas v1
 * (`/login`, `/cambia_contraseña`, `/nueva_contraseña`) las redirigen a su versión v2 (`RedirectAuthV2`), así que
 * cualquier `navigate("/login")` del portal termina en el login v2. Se agregan conforme se migran; las demás siguen
 * en v1.
 */
export const EMPRESAS_AUTH_V2: readonly string[] = ["mercader", "flux", "wuwei", "kapital_partners", "providencia"];
